import React, { useState } from "react";
import { Link } from "react-router-dom";

const OnboardingChecklist = ({ onPostJob, userId, onShowWizard }) => {
  const [linkCopied, setLinkCopied] = useState(false);

  const applicationLink = `${window.location.origin}/register?ref=${userId}`;

  const handleCopyLink = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(applicationLink).then(() => {
        setLinkCopied(true);
        setTimeout(() => setLinkCopied(false), 2000);
      }).catch(() => {});
    }
  };

  return (
    <div className="bg-bluegray rounded-lg p-6">
      <h2 className="text-xl font-bold text-white mb-2">Let's get your first hire started</h2>
      <p className="text-sm text-lightgray mb-6">Three steps to find your best-fit candidates:</p>

      <ol className="space-y-6">
        {/* Step 1 */}
        <li className="flex items-start gap-3">
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-orange text-white font-bold text-sm mr-3 flex-shrink-0">
            1
          </span>
          <div className="flex-1">
            <p className="text-sm font-bold text-white mb-2">Post your first job</p>
            <button
              onClick={onPostJob}
              className="bg-orange hover:bg-deeporange text-white font-bold py-2 px-4 rounded text-sm"
            >
              Post a Job
            </button>
          </div>
        </li>

        {/* Step 2 */}
        <li className="flex items-start gap-3">
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-orange text-white font-bold text-sm mr-3 flex-shrink-0">
            2
          </span>
          <div className="flex-1">
            <p className="text-sm font-bold text-white mb-2">Add Superstar Targets to your job</p>
            <Link
              to="/how-to-pick-great-targets"
              className="bg-deepblue text-lightgray border border-lightblue py-2 px-3 rounded hover:bg-bluegray text-sm inline-block"
            >
              Learn About Targets
            </Link>
          </div>
        </li>

        {/* Step 3 */}
        <li className="flex items-start gap-3">
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-orange text-white font-bold text-sm mr-3 flex-shrink-0">
            3
          </span>
          <div className="flex-1">
            <p className="text-sm font-bold text-white mb-2">Share your application link</p>
            <button
              onClick={handleCopyLink}
              className="bg-deepblue text-lightgray border border-lightblue py-2 px-3 rounded hover:bg-bluegray text-sm"
            >
              Copy Link
            </button>
            <div aria-live="polite" className="text-sm text-green-400 mt-1 h-5">
              {linkCopied ? "Link copied!" : ""}
            </div>
          </div>
        </li>
      </ol>

      <p className="text-sm text-lightgray mt-6">
        Need help?{" "}
        <button
          onClick={onShowWizard}
          className="text-lightblue underline hover:text-orange cursor-pointer bg-transparent border-0 p-0"
        >
          Launch the setup guide
        </button>
      </p>
    </div>
  );
};

export default OnboardingChecklist;
